import { Component, Inject, Input, OnChanges, OnInit } from "@angular/core";
// import { DetailsModalComponent } from '../details-modal/details-modal.component';
import {
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
@Component({
  selector: 'app-consistency-check',
  standalone: false,

  templateUrl: './consistency-check.component.html',
  styleUrl: './consistency-check.component.scss'
})
export class ConsistencyCheckComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    console.log("Data received in modal:", data);
    this.consistencyData = this.data.consistencyChecksData;
    this.dataSummary = this.data.dataSummary;
  }
  consistencyChecks = true;
  @Input() checksData;
  consistencyData = [];
  dataSummary = [];
  disableNextBtn = false;
  ngOnInit(): void {
    // let { consistencyData, dataSummary } = this.checksData();
    this.consistencyData = this.data.consistencyChecksData;
    this.dataSummary = this.data.dataSummary;
    let temp = this.consistencyData.find((obj) => !obj.check);
    if (temp) {
      this.disableNextBtn = true;
    } else {
      this.disableNextBtn = false;
    }
    // this.dialog.open(DetailsModalComponent, {
    // data: {
    // closeModal: this.closeModal.bind(this),
    // planName: this.planName,
    // mode: this.mode,
    // savePlan: this.savePlan.bind(this),
    // },
    // });
  }
  // ngOnChanges() {
  //   let { consistencyData, dataSummary } = this.checksData();
  //   this.consistencyData = consistencyData;
  //   this.dataSummary = dataSummary;
  // }
  ViewClick(val) {
    let obj = this.dataSummary.filter((obj) => {
      return obj.name === val;
    });
    // this.dialog.open(DetailsModalComponent, {
    //   data: {
    //     values: obj[0]['data'],
    //     title: val,
    //   },
    // });
  }
  toggle() {
    // this.consistencyChecks = !this.consistencyChecks;
  }
  next() {
    this.data.syncCsvDataWithTool();
  }
}
